export default __webpack_public_path__ + "static/media/Zoomout.4962aa99.svg";